/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from 'rxjs';
import { SearchableProvider } from "src/app/model/interface";
import { RestResponse } from "../model";
import { environment } from "../research.env";


@Injectable()
export class IbisProvider implements SearchableProvider {
  constructor(
    private http: HttpClient
  ) {
  }

  getSearchType(): string {
    return 'IBIS';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return undefined;
  }

  search(query?: string, id?: string): Observable<any> {
    return this.http
      .get<any>(`${environment.API_URL}${environment.ENDPOINT_PREFIX}/ibis?query=${query}`);
  }
}
